import { Icon } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row, UncontrolledTooltip } from 'reactstrap';

import {
  Career,
  Period,
} from '../../../../components/careerSelector/academicInformationTypes';
import { useUserState } from '../../../../hooks/useUserState';
import { TranslationsKeys } from '../../../../locales/translations';

interface StudentInfoCardProps {
  career?: Career;
  period?: Period | null;
  creditsContracted: number | null;
}

export default function StudentInfoCard({
  career,
  period,
  creditsContracted,
}: StudentInfoCardProps) {
  const { t } = useTranslation(TranslationsKeys.PETITIONS);
  const { userData } = useUserState();

  const text = useMemo(() => {
    const prefix = 'creditReliquidation.studentInfo';
    return {
      program: t(`${prefix}.program`),
      period: t(`${prefix}.period`),
      phone: t(`${prefix}.phone`),
      email: t(`${prefix}.email`),
      level: t(`${prefix}.level`),
      recommendedCredits: t(`${prefix}.recommendedCredits`),
      recommendedCreditsTooltip: t(`${prefix}.recommendedCreditsTooltip`),
    };
  }, [t]);

  return (
    <div className="bg-light p-4 mb-4">
      <Row>
        <Col md={3} className="mb-3">
          <label className="fs-12 text-uppercase text-dark fw-600 mb-1">
            {text.program}
          </label>
          <p className="fs-16 text-dark mb-0">{career?.name ?? '-'}</p>
        </Col>
        <Col md={3} className="mb-3">
          <label className="fs-12 text-uppercase text-dark fw-600 mb-1">
            {text.period}
          </label>
          <p className="fs-16 text-dark mb-0">{period?.name ?? '-'}</p>
        </Col>
        <Col md={3} className="mb-3">
          <label className="fs-12 text-uppercase text-dark fw-600 mb-1">
            {text.phone}
          </label>
          <p className="fs-16 text-dark mb-0">{userData?.phone ?? '-'}</p>
        </Col>
        <Col md={3} className="mb-3">
          <label className="fs-12 text-uppercase text-dark fw-600 mb-1">
            {text.email}
          </label>
          <p className="fs-16 text-dark mb-0">{userData?.email ?? '-'}</p>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <label className="fs-12 text-uppercase text-dark fw-600 mb-1">
            {text.recommendedCredits}
            <span
              id="tooltip-recommended-credits"
              className="ms-1 cursor-pointer"
            >
              <Icon name="information" size="14px" />
            </span>
          </label>
          <UncontrolledTooltip
            placement="right"
            target="tooltip-recommended-credits"
          >
            {text.recommendedCreditsTooltip}
          </UncontrolledTooltip>
          <p className="fs-16 text-dark mb-0 fw-700">
            {creditsContracted ?? '-'}
          </p>
        </Col>
      </Row>
    </div>
  );
}
